// extracted by mini-css-extract-plugin
module.exports = {"swatchPicker":"Yt","thumbWrap":"Zt","selectedSwatch":"_t","swatchThumbnail":"au","swatchThumbnailPlaceholder":"bu"};